import { useState } from 'react'
import uniqueId from 'lodash/uniqueId'
import createUID from '../utils/createUid'

export default function useUniqueId(prefix, len) {
	const [id] = useState(() => `${uniqueId(prefix)}-${createUID(len)}`)
	return id
}
